import * as React from 'react'
import { IPet } from '../../interfaces/types.ts'
import { deviceFromPet } from '../../helpers/dataHelpers.ts'
import { PetEventsButton } from '../common/buttons/PetEventsButton.tsx'
import { CheckinRateButton } from '../common/buttons/CheckinRateButton.tsx'
import { EditPetButton } from '../common/buttons/EditPetButton.tsx'
import { PetHistoryButton } from '../common/buttons/PetHistoryButton.tsx'
import { SleepModeButton } from '../common/buttons/SleepModeButton.tsx'
import { isSleepFeatureEnabled } from '../../helpers/sleepHelper.ts'
import dataStore from '../../store/dataStore.ts'
import './Dashboard2.css'
import { FindButton } from '../common/buttons/FindButton.tsx'

interface Props {
    pet: IPet
    show: boolean
    disabled: boolean
}

export const DeviceControls: React.FC<Props> = (props) => {
    const {pet, show, disabled} = props

    const device = deviceFromPet(pet)
    const account = dataStore(s => s.account)
    const sleepEnabled = isSleepFeatureEnabled(account)
    const isSleeping = device?.status.sleeping === true
    const commandInProgress = !!device?.status.deviceCommandInProgressStatus
    const commandDisabled = disabled || isSleeping || commandInProgress

    const panel = (
        <div id={'device-controls'}
             className={`${show ? 'show' : ''} popup w-full h-full bg-primary text-primary-content rounded-xl ml-1 p-2 flex flex-col gap-2`}>
            <FindButton disabled={commandDisabled} device={device}/>
            <CheckinRateButton tracker={device} outline textColor={'text-primary-content'} disabled={commandDisabled} />
            {sleepEnabled && <SleepModeButton tracker={device} outline disabled={commandDisabled} />}
            <PetHistoryButton pet={pet} outline />
            <PetEventsButton pet={pet} outline/>
            <EditPetButton pet={pet} outline/>
        </div>
    )
    return panel
}
